module.exports = __webpack_public_path__ + "media/record_guide.db2da45e.mp4";